import React, { useState, useEffect, useCallback } from 'react';
import ComboSelector, { TipoClave } from '../UI/campos/ComboSelector.js';
import MensajeError from '../UI/MensajeError.js';
import useGetListaURL from '../../hooks/useGetListaURL.js';
import { ApellidoNombre } from '../funciones/FuncionesPersona.js';

const SelectArbitro = (props) => {
  const idPais = props.idPais;
  const fecha = props.fecha;
  const internacional = props.internacional;
  const arbitroActual = props.arbitroActual;
  const [lista, setLista] = useState([]);
  const { isCargando, erroresGetLista, fetchData, resetErroresGetLista } = useGetListaURL();

  const apellidoNombreArbitro = useCallback(
    (arbitro) => {
      return (
        ApellidoNombre(arbitro) +
        (!idPais && arbitro?.paisArbitro ? ' (' + arbitro.paisArbitro?.nombre + ')' : '')
      );
    },
    [idPais]
  );

  useEffect(() => {
    resetErroresGetLista();
  }, [resetErroresGetLista]);

  useEffect(() => {
    const armarLista = (lista) => {
      const nuevaLista = lista.map((arbitro) => ({
        ...arbitro,
        apellidoNombre: apellidoNombreArbitro(arbitro),
      }));
      setLista(nuevaLista);
    };

    if (fecha) {
      let url = '';
      url = idPais ? 'paises/' + idPais + '/arbitros' : 'arbitros';
      let separador = '?';
      if (fecha) {
        url += separador + 'fecha=' + fecha;
        separador = '&';
      }
      if (internacional) {
        url += separador + 'internacional=true';
      }
      fetchData(url, armarLista);
    } else {
      setLista([]);
    }
  }, [idPais, fecha, internacional, fetchData, apellidoNombreArbitro]);

  const onArbitroElegido = (arbitroElegido) => {
    props.onArbitroElegido(arbitroElegido);
  };

  return (
    <React.Fragment>
      <ComboSelector
        lista={lista}
        valorActual={apellidoNombreArbitro(arbitroActual)}
        campoClave={TipoClave.ID}
        campoDescripcion={'apellidoNombre'}
        isCargando={isCargando}
        onItemElegido={onArbitroElegido}
      />
      <MensajeError errores={erroresGetLista} />
    </React.Fragment>
  );
};

export default SelectArbitro;
